// extracted by mini-css-extract-plugin
export default {"card":"c-e_ek","card_styleDefault":"c-e_el","card_styleRed":"c-e_em"};